import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function saveDiagnostic(payload) {
  const res = await api.post("/diagnostics", payload);
  return res.data;
}

export function reportUrl(id) {
  return `${API}/diagnostics/${id}/report`;
}
